import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * BackButton
 * - Ser ut som din vanliga "Tillbaka till Dashboard"-knapp genom att använda samma klassnamn.
 * - Default-beteende: gå ett steg tillbaka i historiken.
 * - Alternativt: skicka `to="/någon/sida"` för att gå till en specifik route.
 *
 * OBS! Byt className här nedan till den/ de som ditt BackToDashboard använder,
 * t.ex. "back-to-dashboard" eller "back-header" + "back-btn", så får du exakt samma stil.
 */
export default function BackButton({
  to = null,              // ex. "/login" – om null används history back
  label = 'Tillbaka',
  className = 'back-to-dashboard', // <-- byt till samma root-klass som BackToDashboard använder
  buttonClassName = 'btn-back',    // <-- byt till samma knapp-klass som BackToDashboard använder
}) {
  const navigate = useNavigate();

  const onClick = (e) => {
    e.preventDefault();
    if (to) navigate(to, { replace: false });
    else navigate(-1);
  };

  return (
    <div className={className}>
      <button type="button" className={buttonClassName} onClick={onClick}>
        ← {label}
      </button>
    </div>
  );
}
